import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Enum } from './../../utility/enum.enum';
import { IesHttpClient } from '../ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';
import { AppGlobals } from './../../Common/Services/app.global';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SharedService implements OnInit {
  private adminFormData: any;
  private regionsData: any;
  private countriesData: any;
  private virtualLocationCountriesData: any;
  private keyboardTypeData: any;
  private businessCenterData: any;
  private stateData: any;
  private cityData: any;
  private groupData: any;
  private timeZoneData: any;
  private locationData: any;
  private locationMappedWithBCenterData: any;
  private officeData: any;

  constructor(private _http: HttpClient, private _httpClient: IesHttpClient, private appGlobal: AppGlobals) {

  }

  ngOnInit() {
  }

  get locationList() {
    return this.locationData;
  }

  set locationList(values: any) {
    this.locationData = values;
  }

  get locationMappedWithBCenterList() {
    return this.locationMappedWithBCenterData;
  }

  set locationMappedWithBCenterList(values: any) {
    this.locationMappedWithBCenterData = values;
  }

  get keyboardTypeList() {
    return this.keyboardTypeData;
  }

  set keyboardTypeList(values: any) {
    this.keyboardTypeData = values;
  }

  get regionList() {
    return this.regionsData;
  }

  set regionList(values: any) {
    this.regionsData = values;
  }

  get countryList() {
    return this.countriesData;
  }

  set countryList(values: any) {
    this.countriesData = values;
  }

  get virtualLocationCountryList() {
    return this.virtualLocationCountriesData;
  }

  set virtualLocationCountryList(values: any) {
    this.virtualLocationCountriesData = values;
  }

  get stateList() {
    return this.stateData;
  }

  set stateList(values: any) {
    this.stateData = values;
  }

  get cityList() {
    return this.cityData;
  }

  set cityList(values: any) {
    this.cityData = values;
  }

  get businessCenterList() {
    return this.businessCenterData;
  }

  set businessCenterList(values: any) {
    this.businessCenterData = values;
  }

  get proctorGroupList() {
    return this.groupData;
  }

  set proctorGroupList(values: any) {
    this.groupData = values;
  }

  get timeZoneList() {
    return this.timeZoneData;
  }

  set timeZoneList(values: any) {
    this.timeZoneData = values;
  }


  get officeList(): any {
    return this.officeData;
  }

  set officeList(data: any) {
    this.officeData = data;
  }

  // call API to get User Profile
  getUserProfile() {
    return this._httpClient.get(AppUrl.candidateProfile, `?userId=${this.appGlobal.userId}`);
  }

  // call API to get Country List
  searchCountries(urlParams) {
    return this._httpClient.get(AppUrl.searchCountries, urlParams);
  }

  // call API to get address List for exams
  getExamAddressList(urlParams: string) {
    return this._httpClient.get(AppUrl.getExamAddressList, urlParams);
  }

  // call API to get a List of locations
  getPublicLocations() {
    return this._http.get("/individualexamscheduler/services/public/v1/locations.json");
  }

  // call API to get Exams List
  getEligibilities(urlParams: string) {
    return this._httpClient.get(AppUrl.getEligibilities, urlParams);
  }

  // to get address of a lat, long
  getAddressOfLatLng(lat: any, lng: any) {
    let url: string = "http://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng + "&sensor=true";
    return this._http.get(
      url
    );
  }

  // call API to upload Id
  uploadId(formData: any) {
    formData.append('userId', this.appGlobal.userId);
    return this._httpClient.post(AppUrl.candidateUploadId, formData);
  }

  // call API to cancel exam
  cancelExam(params: any) {
    params.userId = this.appGlobal.userId;
    return this._httpClient.post(AppUrl.cancelExam, params);
  }

  // call API to get Exams List
  getTimeDiff(urlParams: string) {
    return this._httpClient.get(AppUrl.getTimeDiff, urlParams);
  }

  // get admin data
  get adminData() {
    return this.adminFormData;
  }

  // set admin selected data
  set adminData(values: any) {
    this.adminFormData = values;

  }


  //Save, Update Exams
  saveNewEntity(value: any, type: number) {
    let param = { type: type, code: value };
    return this._httpClient.post(AppUrl.addEntity, param);
  }



  /* Change status Active or Retire
   * @param identityId - This is Id of particular record
   * @param identityType - Type for which you have to chang status like Koala or Location or Admin
   * @parm  status -  What status you have to do
  */
  changeStatus(identityId: number, identityType: number, status: number) {
    let param = { identityId: Number(identityId), identityType: identityType, status: status };
    return this._httpClient.post(AppUrl.changeStatus, param);
  }

  // Request Function to get data for search fields
  getComboFieldsData(outputType: number, fn) {
    let params = "?outputType=" + outputType;
    this.requestDataForCombo(params).subscribe((response: any) => {
      if (response.response) {
        let resp = { response: response.response.results };
        return fn(resp);
      }
    }, error => { });
  }

  requestDataForCombo(urlParams: any) {
    return this._httpClient.get(AppUrl.requestDataForCombo, urlParams);
  }

  loadCountryStateCityData() {
    if (!this.countryList) {
      this.getComboFieldsData(Enum.Country, (response) => {
        this.countryList = response.response;
      });
    }

    if (!this.stateList) {
      this.getComboFieldsData(Enum.State, (response) => {
        this.stateList = response.response;
      });
    }
    if (!this.cityList) {
      this.getComboFieldsData(Enum.City, (response) => {
        this.cityList = response.response;
      });
    }
  }

  getUsers(urlParams) {
    return this._httpClient.get(AppUrl.getUsers, urlParams);
  }

  /**
   * Used for Global admin, site admin and regional admin
   * @param params - query string params
   */
  saveAdminDetail(params: any, roleType: number) {
    params.roleType = roleType;
    return this._httpClient.post(AppUrl.addUpdateAdmin, params);
  }

  /**
   *
   * @param params - required params
   * @param roleType - for which role you have to perform retire operations (Global admin, regional admin , site admin)
   */
  retireActivateAdmin(params: any) {
    return this._httpClient.post(AppUrl.retireAdmin, params);
  }

  /**
   * service to download the uploaded document/pdf (png/jpeg/pdf)
   * @param params - required params
   */
  downloadFile(params: any) {
    return this._httpClient.downloadFile(AppUrl.downloadApprovalId, params);
  }

  /**
   * service to download the csvs
   * @param params - required params
   */
  downloadEligibilitiesCsv(params?) {
    return this._httpClient.downloadFile(AppUrl.downloadEligibilities, params);
  }

  /**
   * service to download the csvs
   * @param params - required params
   */
  downloadEligibilitiesForProctorSchedulingCsv(params?) {
    return this._httpClient.downloadFile(AppUrl.downloadEligibilitiesForProctorScheduling, params);
  }

  /**
   * service to get Candidate/Admin notifications
   * @param params - required params
   */
  getNotifications() {
    return this._httpClient.get(AppUrl.getNotification);
  }

  /**
   * service to update Candidate notification
   * @param params - required params
   */
  updateNotificationStatus(params: any) {
    return this._httpClient.put(AppUrl.updateNotification, params);
  }

  /**
   * service to logout the user from back-end
   */
  logoutUser() {
    return this._httpClient.delete(AppUrl.logoutUser);
  }

    /**
   * to read settings.json file a http request is send.
   * this. is done so that one can change the value in settings.json after build also, changed value will be updated
   */
  getSettingsJSON(): Observable<any> {
    return this._http.get(AppUrl.settings);
  }

  getVersion() {
    let params = "?" + new Date().getTime();
    return this._http.get(AppUrl.version + params);
  }

  getUserPermissions() {
    return this._httpClient.getPermissions();
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/shared.service.ts